import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Company } from 'src/models/company.model';

@Injectable({
  providedIn: 'root',
})
export class FilesControlService {
  baseUrl = environment.apiUrl + 'RecordsDLP/';
  baseUrl2 = environment.apiUrl + 'Company/';
  urlReport = environment.apiUrl + 'Report/';

  constructor(private http: HttpClient, private router: Router, private _location: Location) {}

  getAllFiles(page: number, filters, pageSize): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + `getFileControlInformation?page=${page}&pageSize=${pageSize}`, { observe: 'response', params: filters });
  }

  getFileHistoryById(page: number, filters, pageSize): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + `getFileHistoryById?pg=${page}&pageSize=${pageSize}`, { observe: 'response', params: filters });
  }

  getFileSummaryById(filters): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + `getFileSummaryById`, { observe: 'response', params: filters });
  }

  getFileInfoById(id): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + `getFileInfoById`, { observe: 'response', params: id });
  }

  getLocations(): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + `locations`, { observe: 'response' });
  }

  getOperations(): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + `operations`, { observe: 'response' });
  }

  setFileActionsById(filters, id): Observable<HttpResponse<any>> {
    return this.http.post<any>(this.baseUrl + `SetFileActionsById?id=${id}`, filters);
  }


  generateGeneraFilesControlReport(filters, language): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.urlReport + `filesControl?culture=${language}`, { observe: 'response', params: filters });
  }

  importCsv(file, companyId): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post(this.baseUrl + `importCompanyUsers?companyId=${companyId}`, formData);
  }
}
